import { K8sProvider, Cloud } from '@cast/shared-types';
import {
  NodeRoles,
  ClusterDisplayStatus,
  AgentStatus,
  ClusterStatus,
  Cluster,
} from '@cast/types';

const cluster: Cluster = {
  id: 'f2f475df-5006-4c83-993b-aa894f95e70b',
  name: 'eks-test',
  organizationId: '0be6d328-6d75-447d-9c41-d1ac8e846fac',
  credentialsId: '',
  eks: {
    clusterName: 'eks-test',
    region: 'us-west-2',
    accountId: '028075177508',
  },
  region: {
    name: 'us-west-2',
    displayName: 'US West (Oregon)',
  },
  createdAt: '2021-03-22T12:29:54.817247Z',
  status: ClusterStatus.READ_ONLY,
  agentStatus: AgentStatus.ONLINE,
  agentSnapshotReceivedAt: '2021-03-22T12:29:54.817247Z',
  providerType: K8sProvider.EKS,
  displayStatus: ClusterDisplayStatus.READ_ONLY,
};

const nodesResponse = [
  {
    id: '753f5734-5340-4838-a686-aa54e25e03aa',
    name: 'ip-192-168-3-141.us-west-2.compute.internal',
    cloud: Cloud.aws,
    instanceType: 'm5.large',
    spotConfig: {
      isSpot: false,
      price: '',
    },
    state: { phase: 'ready' },
    role: NodeRoles.master,
  },
];

const rawClusterResponse: Cluster = cluster;

const rawClustersResponse: { items: Cluster[] } = {
  items: [cluster],
};

export const clusterFixtures = {
  cluster: {
    nodes: nodesResponse,
    entity: cluster,
    detailsResponse: rawClusterResponse,
    listResponse: rawClustersResponse,
  },
  register: {
    script: `curl -H "Authorization: Token <token>" /v1/agent.yaml | kubectl apply -f -`,
  },
};
